module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/foxrun-572.0bd41a7a8f2a557d.jpg"+" 572w",
        images: [{path: "https://static.sniffspot.com/packs/img/foxrun-572.0bd41a7a8f2a557d.jpg",width: 572,height: 500}],
        src: "https://static.sniffspot.com/packs/img/foxrun-572.0bd41a7a8f2a557d.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/foxrun-572.0bd41a7a8f2a557d.jpg"},
        
        width: 572,
        height: 500
      }